<template>
  <div :class="status ? 'addressList open' : 'addressList close'" ref="addressList">
    <div class="button" ref="button" @click="seeMore()" v-if="showMore">
      {{ status ? $lang('收起') : $lang('查看更多') }}
    </div>
    <div v-for="(item, index) in treeDto" :key="index" class="item" ref="tagitem">{{ item }}</div>
  </div>
</template>
<script lang="ts" setup>
  import { ref, watch, nextTick } from 'vue'
  const status = ref(false)
  const showMore = ref(false)
  type Props = {
    treeDto: any
  }
  const props = defineProps<Props>()
  const seeMore = () => {
    status.value = !status.value
  }
  const addressList = ref()
  const tagitem = ref()
  watch(
    props.treeDto,
    (value) => {
      nextTick(() => {
        let totalW = 0
        if (tagitem.value) {
          for (const item of tagitem.value) {
            totalW += item.clientWidth
          }
          if (totalW > addressList.value.clientWidth) {
            showMore.value = true
          } else {
            showMore.value = false
          }
        }
      })
    },
    {
      deep: true,
      immediate: true
    }
  )
</script>
<style scoped lang="less">
  .addressList {
    display: inline-block;
    .item {
      display: inline-block;
      border: 1px solid #dcdee1;
      height: 32px;
      background: #f2f2f2;
      margin-right: 10px;
      margin-bottom: 10px;
      padding: 5px 10px;
      border-radius: 8px;
      text-align: center;
    }
  }
  .close {
    height: 32px;
    overflow: hidden;
  }
  .open {
    height: 200px;
    overflow: auto;
  }
  .button {
    // position:absolute;
    // right:10px;
    float: right;
    text-align: center;
    cursor: pointer;
    border: 1px solid #dcdee1;
    height: 32px;
    padding: 5px 10px;
    border-radius: 8px;
  }
</style>
